<template>
<div :class="{'container-fluid':!isSubComponent}" class="bg-white">

	<service-toolbar v-if="!isSubComponent && module == 'Services'" heading="Personnel">
		<button class="btn btn-success float-right" v-on:click="addEmployees"><i class="fa fa-plus"></i> Add Employee</button>
	</service-toolbar>
	<service-contract-toolbar v-else-if="module == 'Contracts'"
		:hide-heading-widget="true"
		:customer-name="customerName">
		<template slot="toolbar-slot">
			<button class="btn btn-success float-right" v-on:click="addEmployees"><i class="fa fa-plus"></i> Add Employee</button>
		</template>
	</service-contract-toolbar>

	<component :is="noWidget ? 'div' : 'widget'">
		<div class="d-flex justify-content-between">
			<button v-if="jobType == 'Project' && !isSubComponent && $store[storeLocation] && 'id' in $store[storeLocation]" class="btn btn-success float-right" v-on:click="addEmployees"><i class="fa fa-plus"></i> Add Employees</button>

			<h2 v-if="!heading">
				Personnel<br>
				<small v-if="$store[storeLocation] && recordNumField in $store[storeLocation]">{{jobType}} #{{$store[storeLocation][recordNumField]}} <span v-if="$store[storeLocation].job_name">: {{$store[storeLocation].job_name}}</span>
				</small>
			</h2>

			<component v-else :is="isSubComponent ? 'h3' : 'h2'">
				{{heading}}
			</component>

			<div>
				<button v-if="isSubComponent && hasModulePermWrite(module) && 'id' in $store[storeLocation]" class="btn btn-success" 
					v-on:click="addEmployees">
					<i class="fa fa-plus"></i> 
					Add Employees
				</button>
			</div>
		</div>

		<p v-if="!('id' in $store[storeLocation])">Save the job first to add personnel</p>
		
		<table-list
			:records="mutatedUsers"
			:fields="fields"
			:record-name="jobType+' Personnel'"
			:has-edit="hasModulePermWrite(module)"
			:hide-record-count="true"
			v-on:edit="editUser">

		</table-list>
	</component>

	<modal-dialog
		:modal-visible="editModal.visible"
		:title="editModal.title"
		confirm-button-text="Save"
		v-on:confirm="saveUser"
		v-on:closeModal="editModal.visible = false">

		<template v-if="editModal.edit">

			<router-link :to="editModal.record.fullName.link" class="form-control-plaintext">{{ editModal.record.fullName.text }}</router-link>
				
			<form-group label="Roles" col-class="col-sm-2">
				<field :params="{type: 'select-multi', options: rolesOptions}" v-model="editModal.payload[0].role_ids"></field>
			</form-group>

			<button v-if="editModal.edit" v-on:click="removeUser" type="button" class="btn btn-outline-danger btn-sm float-right"><i class="fa fa-times"></i> Remove User</button>
		</template>
		<template v-else>
			<div v-for="(item,index) in editModal.payload">
				
				<form-group label="User" col-class="col-md-4">
					<field :params="{type: 'select',options:filteredUsersOptions}" v-model="editModal.payload[index].user_id"></field>
				</form-group>
					
				<form-group label="Roles" col-class="col-md-4">
					<field :params="{type: 'select-multi', options: rolesOptions}" v-model="editModal.payload[index].role_ids"></field>
				</form-group>

				<hr v-if="index < editModal.payload.length - 1">

			</div>
			<button v-if="editModal.payload.length > 0 && editModal.payload[editModal.payload.length-1].user_id > 0" type="button" class="btn btn-sm btn-primary float-right" v-on:click="addEmployeeRow">
				<i class="fa fa-plus"></i>
				Add Employee
			</button>
		</template>

	</modal-dialog>
</div>
</template>

<script>

import UploadField from "@/components/UploadField"
import FormGroup from "@/components/FormGroup"
import Field from "@/components/Field"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Widget from "@/components/Widget"

import ServiceToolbar from "./services/ServiceToolbar"
import ServiceContractToolbar from "@/pages/project/service_contract/ServiceContractToolbar"
import ServiceMixins from "@/mixins/ServiceMixins.js"
import JobMixins from "@/mixins/JobMixins.js"
import ServiceContractMixins from "@/mixins/ServiceContractMixins.js"

export default {

	name: 'PersonnelTab',
	components: {
		FormGroup,
		Field,
		UploadField,
		TableList,
		ModalDialog,
		ServiceToolbar,
		Widget,
		ServiceContractToolbar
	},
	mixins: [ServiceMixins,ServiceContractMixins,JobMixins],
	props: ["isSubComponent","noWidget","heading","module","storeLocation","jobType"],
	data() {
		return {
			personnel: [],
			fields: [],
			usersOptions: [],
			editModal: {
				visible: false,
				title: "Edit User",
				payload: [],
				record: {},
				edit: false
			}
		}
	},
	computed: {
		rolesOptions() {
			return this.optionify(this.$store.jobPersonnelRoles,"title")
		},
		recordNumField() {
			let recordNumField = "contract_num"
			if (this.jobType != "Service Contract")
				recordNumField = "job_num"

			return recordNumField
		},
		filteredUsersOptions() {
			return this.usersOptions.filter(user => {
				//look for it in mutatedusers
				let omit = false
				this.mutatedUsers.forEach((userFromList,index) => {

					if (userFromList.user_id == user.value)
						omit = true
				})
				if (!omit)
					return true

			})
			
		},
		mutatedUsers() {
			//build the list of users, showing each user only once, but indicating all their assigned roles
			let vm = this

			let mutatedPersonnel = []
			if (this.personnel) {
				this.personnel.forEach((row,index)=>{
					let user = {}

					let userExistsInList = false

					//see if user has already been added to list
					mutatedPersonnel.forEach((userFromList,index)=>{
						if (userFromList.user_id == row.id) {
							//he has
							user = userFromList
							userExistsInList = true
						}
					})

					//create fullName value
					user.fullName = {
						link: "/employee/"+row.slug+"/profile",
						text: row.first_name+" "+row.last_name
					}
					user.user_id = row.id

					//look for role id in fields key
					vm.fields.forEach(field => {

						if (field.key == row.personnel_role_id) {
							//found the role for this user
							user[field.key] = 1
						}
					})

					if (!userExistsInList)
						mutatedPersonnel.push(user)

				})
			}

			//filter down to users who aren't selected yet

			return mutatedPersonnel
		},
		userOtherFieldKey() {
			let other_field
			if (this.storeLocation == 'service')
				other_field = "service_id"
			else if (this.storeLocation == "serviceContract")
				other_field = "service_contract_id"
			else if (this.storeLocation == "project")
				other_field = "job_id"

			return other_field
		}
	},
	watch: {
		'$store.project'() {
			if (this.jobType == "Project" && this.$store.project)
				this.personnel = this.$store.project && "User" in this.$store.project ? this.$store.project.User : []
		},
		'$store.service'() {
			if (this.jobType == "Service" && this.$store.service)
				this.personnel == this.$store.service && "User" in this.$store.service ? this.$store.service.User : []
		},
		'$store.serviceContract'() {
			if (this.jobType == "Service Contract" && this.$store.serviceContract)
				this.personnel = this.$store.serviceContract.User
		}
	},
	methods: {
		editUser(record) {

			this.editModal.visible = true

			let role_ids = []
			//assign selected roles to role_ids
			for (var key in record) {
				if (Number.isInteger(+key)) { //any key that is a number references a personnel role id
					role_ids.push(key)
				}
			}

			this.editModal.record = record

			this.editModal.payload = [{
				user_id: record.user_id,
				role_ids: role_ids
			}]
			this.editModal.edit = true

		},
		saveUser() {

			let route = this.$route.path
			let vm = this

			let promises = []

			this.editModal.payload.forEach(item => {

				let relationKey = "JobPersonnelRole"
				if (vm.storeLocation == 'serviceContract' || vm.storeLocation == 'service')
					relationKey = "ServiceJobPersonnelRole"

				let payload = {
					id: item.user_id,
				}

				payload[relationKey] = {
					'set': item.role_ids,
					'other_field': this.userOtherFieldKey,
					'other_id': this.$store[this.storeLocation].id
				}

				promises.push(vm.postData("User/save",payload,true))
			})

			Promise.all(promises).then(responses => {
				vm.editModal.visible = false

				//if any errors, stop processing
				let hasErrors = false
				responses.forEach(response => {
					if (!response.success)
						hasErrors = true
				})

				if (!hasErrors)
					vm.alertSaved()

				if (vm.storeLocation == 'service')
					vm.setService()
				else if (vm.storeLocation == "serviceContract")
					vm.setContract()
				else
					vm.$emit("fetchJob")
				
			})		
		},
		addEmployees() {
			this.editModal.visible = true
			this.editModal.title = "Add Employees to "+this.jobType
			this.editModal.payload = [{
				user_id: null,
				role_ids: []
			}]
			this.editModal.edit = false
		},
		addEmployeeRow() {
			this.editModal.payload.push({
				user_id: null,
				role_ids: []
			})
		},
		removeUser() {
			let vm = this

			let relationKey = "JobPersonnelRole"
			if (vm.storeLocation == 'serviceContract' || vm.$storeLocation == 'service')
				relationKey = "ServiceJobPersonnelRole"

			let userPayload = {
				id: this.editModal.payload[0].user_id
			}

			userPayload[relationKey] = {
				'set': [],
				'other_field': this.userOtherFieldKey,
				'other_id': this.$store[this.storeLocation].id
			}

			this.saveRecord("User",userPayload, function(response){
				if (response.success) {
					vm.editModal.visible = false
					vm.alertSaved()

					if (vm.storeLocation == 'service')
						vm.setService()
					else if (vm.storeLocation == "serviceContract")
						vm.setContract()
					else
						vm.$emit("fetchJob")
				}

			})
		},
		setService() {
			let vm = this

			this.fetchService().then(response => {
				vm.$set(vm.$store,"service",response.data)
				vm.personnel = response.data.User
			})
		},
		setContract() {
			let vm = this
			this.fetchContract(this.$route.params.slug).then(response => {
				if (response.success && "User" in response.data)
					vm.personnel = response.data.User
			})
		},
		fetchData() {
			let vm = this

			this.spinner(true)

			let promises = [
				this.getJSON("User/get"),
				this.fetchJobPersonnelRoles()
			]

			if (this.storeLocation == "service")
				promises.push(this.fetchService())
			else if (this.storeLocation == "serviceContract")
				promises.push(this.fetchContract(this.$route.params.slug))

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				vm.fields = [
					{
						label: "Name",
						key: "fullName",
						type: "link"
					}
				]

				vm.usersOptions = vm.optionify(responses[0].data.map(user => {
					user.fullName = user.first_name + " " + user.last_name
					return user
				}),"fullName")

				//assign each role as a field column for the table, with the id as the key
				this.$store.jobPersonnelRoles.forEach((role,index) => {
					vm.fields.push({
						label: role.title,
						key: role.id,
						align:"center",
						type: "boolean"
					})
				})

				if (responses.length == 3) {
					vm.$set(vm.$store,vm.storeLocation,responses[2].data)
					vm.personnel = responses[2].data.User
				}

				/*
				if (vm.mutatedUsers.length == 0) {
					//nobody added yet, add defaults

					if (vm.$store[vm.storeLocation]) {
						let jobDefaults = vm.isValidJSON(this.$store.company.CompanySetting.job_defaults_json) ? JSON.parse(this.$store.company.CompanySetting.job_defaults_json) : {}

						if ("default_users_roles" in jobDefaults) {
							let jobTypeKey = "services"
							if (vm.jobType == 'Project')
								jobTypeKey = "projects"

							if (jobTypeKey in jobDefaults.default_users_roles && jobDefaults.default_users_roles[jobTypeKey] && jobDefaults.default_users_roles[jobTypeKey].length > 0) {
								
								let userPromises = []

								jobDefaults.default_users_roles[jobTypeKey].forEach(user => {

									let relationKey = "JobPersonnelRole"
									if (vm.storeLocation == 'serviceContract' || vm.$storeLocation == 'service')
										relationKey = "ServiceJobPersonnelRole"

									let payload = {
										id: user.user_id
									}

									payload[relationKey] = {
										'set': [user.role_id],
										'other_field': vm.userOtherFieldKey,
										'other_id': vm.$store[vm.storeLocation].id
									}

									userPromises.push(vm.postData("User/save",payload))
								})

								Promise.all(userPromises).then(responses => {
									
									if (vm.storeLocation == 'service') {
										vm.fetchService().then(response => {
											vm.$set(vm.$store,vm.storeLocation,response.data)
											vm.personnel = response.data.User
										})
									}
									else if (vm.storeLocation == 'serviceContract') {
										vm.fetchContract(this.$route.params.slug).then(response => {
											vm.$set(vm.$store,vm.storeLocation,response.data)
											vm.personnel = response.data.User
										})
									}
									else {
										vm.$emit("fetchJob")
									}
								})
							}
						}
					}
				}
				*/
			})
			
		}
	},
	created() {
		this.$emit("fetchJob")
		this.fetchData()
	}

}
</script>

<style type="text/css">

</style>